import { PageId } from 'constants/pages'

export const enum PageIdWoofzPpday75 {
  SUBSCRIPTIONS_PPDAY_75_N = PageId.SUBSCRIPTIONS_PPDAY_75_N,
  CHAT_UPSELL_PPDAY_75 = PageId.CHAT_UPSELL_PPDAY_75,
  UPSELL_PPDAY_75 = PageId.UPSELL_PPDAY_75,
  DOWNLOAD_PPDAY_75 = PageId.DOWNLOAD_PPDAY_75,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
